import { CancelarItemGtoDto } from "./cancelar-item-gto-dto";

export class ProcedimentoCancela {

    constructor(
        public numero?: number,
        public motivo?: string,
        public linha?: number
        
    ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/procedimentoCancela.ts